import * as React from 'react';
import userflow from 'userflow.js';

import { isCypress } from 'bones/utils/environment';
import { isOnPremise } from 'bones/utils/portal/environment';
import { getPortalUserTrackingData } from 'bones/utils/portal/getPortalUserTrackingData';
import { useAnalyticsConsent } from 'bones/utils/portal/useAnalyticsConsent';
import { PortalUser, usePortalUser } from 'bones/utils/portal/usePortalUser';

export const setupUserflow = (user: PortalUser) => {
  const token = process.env.USERFLOW_TOKEN;
  if (!token || isCypress() || isOnPremise()) {
    return;
  }
  userflow.init(token);

  const { email, id, userflow_signature: signature } = user;

  if (!id || !email || !signature) {
    userflow.identifyAnonymous();
    return;
  }

  userflow.identify(email, getPortalUserTrackingData(user), { signature });
};

export const usePortalUserflow = () => {
  const consent = useAnalyticsConsent();
  const enabled = consent !== null && consent.statistics;

  const { data: user, isLoading } = usePortalUser({
    enabled,
    refetchOnWindowFocus: false,
  });

  React.useEffect(() => {
    if (
      !enabled ||
      isLoading ||
      !user ||
      !user.is_authenticated ||
      user.is_ephemeral
    ) {
      if (!isLoading && !isCypress() && userflow.isIdentified()) {
        userflow.reset();
      }
      return;
    }
    setupUserflow(user);
  }, [enabled, isLoading, user]);
};
